import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import $20k3Y$react from "react";
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

function $312ae3b56a94a86e$var$TableHeader(props) {
  return null;
}

$312ae3b56a94a86e$var$TableHeader.getCollectionNode = /*#__PURE__*/_regeneratorRuntime.mark(function getCollectionNode(props, context) {
  var children, columns, _iterator, _step, column, _columns;

  return _regeneratorRuntime.wrap(function getCollectionNode$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        children = props.children, columns = props.columns; // Clear columns so they aren't double added in strict mode.

        context.columns = [];

        if (!(typeof children === 'function')) {
          _context.next = 24;
          break;
        }

        if (columns) {
          _context.next = 5;
          break;
        }

        throw new Error('props.children was a function but props.columns is missing');

      case 5:
        _iterator = _createForOfIteratorHelper(columns);
        _context.prev = 6;

        _iterator.s();

      case 8:
        if ((_step = _iterator.n()).done) {
          _context.next = 14;
          break;
        }

        column = _step.value;
        _context.next = 12;
        return {
          type: 'column',
          value: column,
          renderer: children
        };

      case 12:
        _context.next = 8;
        break;

      case 14:
        _context.next = 19;
        break;

      case 16:
        _context.prev = 16;
        _context.t0 = _context["catch"](6);

        _iterator.e(_context.t0);

      case 19:
        _context.prev = 19;

        _iterator.f();

        return _context.finish(19);

      case 22:
        _context.next = 27;
        break;

      case 24:
        _columns = [];
        (0, $20k3Y$react).Children.forEach(children, function (column) {
          _columns.push({
            type: 'column',
            element: column
          });
        });
        return _context.delegateYield(_columns, "t1", 27);

      case 27:
      case "end":
        return _context.stop();
    }
  }, getCollectionNode, null, [[6, 16, 19, 22]]);
});
/**
 * A TableHeader is a container for the Column elements in a Table. Columns can be statically defined
 * as children, or generated dynamically using a function based on the data passed to the `columns` prop.
 */
// We don't want getCollectionNode to show up in the type definition

var $312ae3b56a94a86e$export$f850895b287ef28e = $312ae3b56a94a86e$var$TableHeader;
export { $312ae3b56a94a86e$export$f850895b287ef28e as TableHeader };